import {getRandomInRange} from '../../../helpers/numbers-helper.js'

export function getFollowupsChanges(action, combatantMap, currentCombatantStateChanges, combatantModels) {
    //Copy the changes.
    let changes = {
        ...currentCombatantStateChanges
    };

    const casterModel = combatantModels[combatantMap.casterId];
    const targetModels = combatantMap.targetIds.map(targetId => { return combatantModels[targetId] });


    //Convert followup actions into Followup Models
    // { actionId, casterId, [targetIds, turnCount }
    const followupActions = action.getFollowupActions(action, casterModel, targetModels).map(followupModel => {
        const turnsToWait = getRandomInRange(
            followupModel.turnRange[0],
            followupModel.turnRange[1]
        );

        return {
            ...followupModel.action,
            turnsToWait: turnsToWait
        };
    });

    //Include followup actions (or empty array if we don't have any followups to add)
    changes.description["followupActions"] = followupActions || [];

    return changes;
}


// WEBPACK FOOTER //
// ./src/battle/lifecycle/description/followups.js